<template>
  <GmapMap
    ref="map"
    :center="map.center"
    :zoom="map.zoom"
    :options="map.options"
    style="width:100%;  height: 100%;"
  >
    <template v-if="route">
      <GmapMarker
        v-for="(stop, sindex) in route.stops"
        :key="`s-${sindex}`"
        :title="stop.name"
        :position="stop.location"
        :icon="{
          url: getMarkerIconUrl(stop.type),
          scaledSize: {
            width: 35,
            height: 41,
            f: 'px',
            b: 'px'
          }
        }"
        @click="$emit('activateStopPopUp', stop.id)"
      />
      <GmapPolyline
        :path="route.path"
        :options="{
          strokeColor: colorLuminance(route.color, -0.5),
          strokeWeight: 7
        }"
      />
      <GmapPolyline
        :path="route.path"
        :options="{
          strokeColor: route.color,
          strokeWeight: 3
        }"
      />
      <GmapMarker
        v-for="(car, index) in cars"
        :key="`c-${index}`"
        :position="car.location"
        :title="car.number"
        :icon="{
          ...iconConfig,
          strokeColor: route.color,
          rotation: car.course ? car.course : 0
        }"
        @click="$emit('activateCarPopUp', car.id)"
      />
    </template>
  </GmapMap>
</template>

<script>
import { gmapApi } from 'vue2-google-maps'

export default {
  name: 'Map',
  props: {
    route: {
      type: Object,
      default: null
    },
    cars: {
      type: Array,
      default: null
    }
  },
  data: () => ({
    map: {
      center: {
        lat: 42,
        lng: -71
      },
      zoom: 10,
      options: {
        disableDefaultUI: true,
        zoomControl: true
      }
    },
    iconConfig: {
      path:
        'm 2.6234226,288.63751 v 0.87648 H 2.3107315 v 0.32326 h 0.3126911 v 7.09644 h 2.881857 V 289.8508 H 5.79284 v -0.32326 H 5.5052796 v -0.89003 z m 0.3493438,0.87332 h 2.13953 v 0.74227 h -2.13953 z',
      anchor: {
        x: 4,
        y: 293
      },
      fillOpacity: 0.9,
      fillColor: '#000000',
      strokeWeight: 1,
      scale: 5
    }
  }),
  computed: {
    google: gmapApi
  },
  watch: {
    route: async function(newRoute) {
      await this.setRouteOnMap(newRoute)
    }
  },
  methods: {
    setRouteOnMap: async function(route) {
      if (route) {
        let bounds = new this.google.maps.LatLngBounds()
        for (let path of route.path) {
          bounds.extend(path)
        }
        let map = await this.$refs.map.$mapPromise
        map.fitBounds(bounds)
      }
    },

    getMarkerIconUrl: function(type) {
      switch (type) {
        case 'train':
          return require('../assets/train-stop.png')
        case 'company':
          return require('../assets/company-stop.png')
        case 'encore':
          return require('../assets/encore-stop.png')
        default:
          return require('../assets/bus-stop.png')
      }
    },
    colorLuminance: function(hex, lum) {
      hex = String(hex).replace(/[^0-9a-f]/gi, '')
      if (hex.length < 6) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2]
      }
      lum = lum || 0

      let rgb = '#',
        c,
        i
      for (i = 0; i < 3; i++) {
        c = parseInt(hex.substr(i * 2, 2), 16)
        c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16)
        rgb += ('00' + c).substr(c.length)
      }

      return rgb
    }
  }
}
</script>
